/**
 * Terra's Login Page with Microsoft sign in
 */

import { Button, Divider, Form, Image, Layout, Space } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import clientLogo from "../assets/image/client_logo.svg";
import MicrosoftLogo from "../assets/image/Microsoft_logo.svg?react";
import terraLogo from "../assets/image/TerraLogo_Login.svg";
import { url } from "../utils/_exports";
const { Content } = Layout;

const LoginPage = (props: any) => {
	const navigate = useNavigate();
	useEffect(() => {
		if (
			localStorage.getItem(`idToken`) &&
			localStorage.getItem(`idToken`) !== undefined
		) {
			navigate(`/dashboard`, { replace: true });
		}
	});

	const onFinish = (values: any) => {
		if (values.username == "admin" && values.password == "admin") {
			localStorage.setItem("isLogin", "true");
			window.location.href = "/dashboard";
		}
	};

	// Login Via Microsoft EntraID
	const MicrosoftSignIn = () => {
		window.location.href = `${url}/login`;
	};

	return (
		<Layout className="login-body">
			<Content>
				<div className="container" style={{ display: "flex" }}>
					<div className="left-container"></div>
					<div className="right-container">
						<Space className="login-container" direction="vertical" size={50}>
							<Space
								style={{ display: "flex", alignItems: "center" }}
								className="login-header-container"
								direction="vertical"
							>
								<Image
									className="no-visual-search"
									src={clientLogo}
									preview={false}
									width={240}
									// style={{ width: "275px" }}
								></Image>
							</Space>
							<Form
								name="login_form"
								className="login-form"
								onFinish={onFinish}
							>
								<Form.Item style={{ marginBottom: "0px" }}>
									{" "}
									<Button
										type="primary"
										htmlType="submit"
										onClick={MicrosoftSignIn}
										className="login-form-button normal-login-button"
									>
										Sign in via Elemental account
									</Button>
								</Form.Item>
								<Divider>Or</Divider>
								<Form.Item>
									<Link to="/">
										<Button
											className="microsoft-login-button w-full leading-1"
											icon={<MicrosoftLogo width={16} height={16} />}
											type="primary"
											onClick={MicrosoftSignIn}
										>
											Sign in with Microsoft
										</Button>
									</Link>
								</Form.Item>
								<span
									style={{
										fontSize: "10px",
										lineHeight: "22px",
										fontWeight: "400",
										color: "#FFFFFF75",
									}}
								>
									Having problems?{" "}
									<a style={{ color: "#299BA3" }}>Contact us</a>
								</span>
							</Form>
						</Space>
						<div className="login-container-footer">
							<span style={{ fontSize: "14px", lineHeight: "22px" }}>
								Powered by
							</span>
							<Image
								className="no-visual-search"
								preview={false}
								height="60px"
								width="150px"
								src={terraLogo}
							/>
						</div>
					</div>
				</div>
			</Content>
		</Layout>
	);
};

LoginPage.propTypes = {};

export default LoginPage;
